import { Api, ApiUrl } from "../../services";
import { mutations as MUTATION, actions as ACTION } from "./types";
const actions = {
  [ACTION.INPUT_SEARCH_ARTICLES]: async (store, dataBody) => {
    return new Promise(async (resolve, reject) => {
      try {
        store.commit(MUTATION.CALLING_API, true);
        let options = {
          limit: dataBody.limit,
          "searches[description]": dataBody.searchDesc
        };
        if (dataBody.searchTitle) {
          options["searches[title]"] = dataBody.searchTitle;
        }
        const res = await Api.helpCenter.get(ApiUrl.helpCenter.articles, { params: options });
        const data = res.data;
        if (res && res.status) {
          store.commit(MUTATION.SEARCH_RESULT, data);
          resolve(data);
        } else {
          throw res;
        }
      } catch (error) {
        reject(error);
      } finally {
        store.commit(MUTATION.CALLING_API, false);
      }
    });
  },
  [ACTION.TUTORIAL_PLAYLIST_BY_ID](store, playlistId) {
    return new Promise(async (resolve, reject) => {
      let id = "";
      switch (playlistId) {
        case "getting-started":
          id = "PLoyQ7pcHx_pRj6sMwBdLihO8SvBjZaJpn";
          break;
        case "about-us-page":
          id = "PLoyQ7pcHx_pQ8lbYAJYzjm_ky128Kgymy";
          break;
        case "high-converting-product-pages":
          id = "PLoyQ7pcHx_pQrXJYRkM9Q75DqiXHp90SJ";
          break;
        case "learning-gempages":
          id = "PLoyQ7pcHx_pRxU8CXjODBxXxr3Pxu6qQD";
          break;
        default:
          id = "PLoyQ7pcHx_pRxU8CXjODBxXxr3Pxu6qQD";
          break;
      }
      const key = "AIzaSyAyRAInKTNDmOYwxFsSWDaXgN526IWh-bo";
      const state = store.state;
      const params = {
        part: "snippet,contentDetails"
      };
      state.loading = true;
      Api.youtube
        .get(ApiUrl.youtube.playlist(id, key), { params: params })
        .then(res => {
          if (res?.data) {
            store.commit(MUTATION.TUTORIAL_PLAYLIST_BY_CATEGORY, {
              id: playlistId,
              items: res.data.items
            });
          }
          resolve(res.data.items);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [ACTION.GET_VIDEO_BY_ID](store, id) {
    return new Promise(async (resolve, reject) => {
      const key = "AIzaSyAyRAInKTNDmOYwxFsSWDaXgN526IWh-bo";
      const params = {
        part: "contentDetails"
      };
      Api.youtube
        .get(ApiUrl.youtube.video(id, key), { params: params })
        .then(res => {
          if (res?.data) {
            resolve(res.data.items[0]);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [ACTION.OPEN_GETHELP_MODAL](store) {
    store.commit(MUTATION.MOMENT_OPEN);
    store.commit(MUTATION.SHOW_MODAL);
  },
  [ACTION.CLOSE_GETHELP_MODAL](store) {
    store.commit(MUTATION.MOMENT_CLOSE);
    store.commit(MUTATION.HIDE_MODAL);
  },
  [ACTION.TOGGLE_GETHELP_MODAL](store) {
    store.commit(MUTATION.TOGGLE_MODAL);
    if(store.state.isShowModal){
      store.commit(MUTATION.MOMENT_OPEN);
    }else{
      store.commit(MUTATION.MOMENT_CLOSE);
    }
  },
  [ACTION.SHOW_ICON_GETHELP](store) {
    store.commit(MUTATION.SHOW_ICON);
  },
  [ACTION.HIDE_ICON_GETHELP](store) {
    store.commit(MUTATION.HIDE_ICON);
  }
};

export default actions;
